import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { AutenticacionService } from "../../../services/autenticacion.service";

@Component({
  selector: 'footer-credito',
  templateUrl: './footer-credito.component.html',
  styleUrls: ['./footer-credito.component.scss']
})
export class FooterCreditoComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //UI attributes
    public isValidToStartCredit : boolean = false;
    public showAuthButton : boolean = false;
    public errors : any = {};
    public isAdmin : boolean = false;
    /**Subscriptions */
    private changeSubscription : any = null;

    constructor(
      private helperService: HelpersService,
      private creditosService: CreditosService,
      private router: Router,
      private autenticacionService : AutenticacionService
    ){
      this.changeSubscription =this.creditosService.changeCredito.subscribe( () => {
        this.setupComponent();
      });
    }

    ngOnInit() {
      
    }

    ngOnDestroy () {
      //Se necesita hacer el unsubscribe cuando se libera el componente, 
      //ya que de no hacerlo se encolan las subscripciones y la función se puede disparar N veces
      this.changeSubscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.idCreditos && this.idCreditos) {
        this.setupByUserType();
        this.setupComponent();
      }
    }

    private setupComponent(){
      this.setupAuthButton(this.idCreditos);
      this.setupStartButton(this.idCreditos);
    }

    public rechazar(){
      //Actualizar el estaus del crédito a Vigentes = 2
      let credito = {
        id : this.idCreditos,
        status : 0
      };

      this.rechazarCredito(credito);
    }

    private rechazarCredito(credito : any){
      this.creditosService.update(credito).subscribe(
        (response)=>
        {
          this.helperService.notification('Credito rechazado', 'Se ha rechazado exitosamente el crédito', 'success');
          this.router.navigate(['/creditos']);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private iniciarCredito(){
      this.creditosService.iniciarCredito(this.idCreditos).subscribe(
        (response)=>
        {
          this.helperService.notification('Credito iniciado', 
          'Se ha actualizado exitosamente la información del crédito', 'success');
          this.router.navigate(['/creditos']);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.showIniciarCreditoErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private setupByUserType(){
      this.autenticacionService.getUser().subscribe(
        (response)=>
        {
          const user = response.json().content;
          
          if(user && user.usuarios_permisos.descripcion === 'Administrador'){
            this.isAdmin = true;
          }
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private setupAuthButton(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.creditosService.requireAuthorization(idCreditos).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.showAuthButton = result.requireAuthorization;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private setupStartButton(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.creditosService.isValidToStartCredito(idCreditos).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.isValidToStartCredit = result.isValid;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    private autorizarCredito(){
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.creditosService.autorizarCredito(this.idCreditos).subscribe(
        (response)=>
        {
          const result = response.json().content;
          //Informar a los otros componentes que el estatus del crédito ha cambiado
          this.helperService.notification('Crédito autorizado', 'Se ha autorizado exitosamente el crédito', 'success');
          this.showAuthButton = false;
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public showIniciarCreditoErrors(errors:any){
      let serviceErrors = {};
      let errorMessages = '';
      
      Object.keys(errors).forEach(function(key){
        errorMessages += errors[key][0];
      });
  
      serviceErrors['iniciarCredito'] = errorMessages;
      
      this.errors = serviceErrors;
    }

}



// WEBPACK FOOTER //
// ./src/app/creditos/components/footer-credito/footer-credito.component.ts